(function () {
  class GameStakeSelection extends PIXI.Container {
    constructor(json) {
      super();

      this.json = json;

      this._countButtonRows = json.countButtonRows;
      this._countButtonsPerRow = json.countButtonsPerRow;
      this._buttonSprite = json.buttonSprite;
      this._buttonTextFontWhite = json.buttonTextFontWhite;
      this._buttonTextFontGreen = json.buttonTextFontGreen;
      this._buttonTextMaxWidth = json.buttonTextMaxWidth;
      this._buttonTextPosOffset = json.buttonTextPosOffset;
      this._screenMaskTextId = json.screenMaskTextId;

      this._goldenBetSelected = false;
      this._goldenBetPlatformEnabled = false;
      this._goldenBetPlatformVisible = false;
      this._canPlaceGoldenBet = false;
      this._goldenBetStakes = undefined;

      if (this._buttonTextPosOffset === undefined) {
        this._buttonTextPosOffset = { x: 0, y: 0 };
      }

      if (this._countButtonRows === undefined) {
        this._countButtonRows = 3;
      }

      this._initialLayoutDone = false;
      this._selectedIndex = -1;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('game:modal', this.onModal.bind(this));

      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));

      this.isActive = false;
      this.visible = false;
    }

    ////////////////////////////////////
    onModal(msg) {
      // Pressing max bet or lucky bet takes us out of modal but we are still visible, keep modal
      // This means the dialog will be still open allowing the player to spin behind the stake dialog - go back to modal if
      // the dialog is still open

      if (this.isActive && msg.reason === undefined) {
        messageBus.post('game:modal', { reason: 'Stake dialog open' });
      }
    }

    initialise() {
      const self = this;

      const stakeController = resourceManager.getController('stakeController');

      this._bg = resourceManager.get(this.json.bgId);
      this._buttonsContainer = resourceManager.get(this.json.buttonsContainerId);
      this._closeButton = resourceManager.get(this.json.closeButtonId);
      this._closeButton.mousedown = this._closeButton.touchstart = function () {
        self.closeDialog();
        self._cancelledCallback();
      };

      this._continueButton = resourceManager.get(this.json.continueButtonId);
      this._continueButton.mousedown = this._continueButton.touchstart = function () {
        self.continuePressed();
      };
      this._continueButtonWhiteText = resourceManager.get(this.json.continueButtonUnselectedTextId);
      this._continueButtonGreenText = resourceManager.get(this.json.continueButtonSelectedTextId);
      this._continueButtonGreenText.visible = false;

      this._goldenBetButtonOn = resourceManager.get('gameStakeSelection:stakeSelection:bg:goldenBetButtonOn');

      this._goldenBetButtonOff = resourceManager.get('gameStakeSelection:stakeSelection:bg:goldenBetButtonOff');

      this._goldenBetButtonOn = resourceManager.get(this.json.goldenBetButtonOnId);
      this._goldenBetButtonOn.mousedown = this._goldenBetButtonOn.touchstart = this.goldenBetOnPressed.bind(this);

      this._goldenBetButtonOff = resourceManager.get(this.json.goldenBetButtonOffId);
      this._goldenBetButtonOff.mousedown = this._goldenBetButtonOff.touchstart = this.goldenBetOffPressed.bind(this);

      // Make the backing sprite also trigger the toggle
      this._goldenBetBacking = resourceManager.get(
        'gameStakeSelection:stakeSelection:bg:stakeSelectionGoldenBetBacking'
      );
      if (this._goldenBetBacking) {
        this._goldenBetBacking.interactive = true;
        this._goldenBetBacking.mousedown = this._goldenBetBacking.touchstart = this.goldenBetBackingPressed.bind(this);
      }

      const maxNumStakeButtons = stakeController.Stakes.length;

      this._stakeButtons = [];
      let stake;
      for (let index = 0; index < maxNumStakeButtons; ++index) {
        let maxWidth = this._buttonTextMaxWidth;
        if (maxWidth === undefined) {
          maxWidth = 80;
        }
        if (this.json.maxWidthPerValue !== undefined) {
          stake = stakeController.Stakes[index];
          for (let i = 0; i < this.json.maxWidthPerValue.length; ++i) {
            if (stake < this.json.maxWidthPerValue[i].lessThan) {
              maxWidth = this.json.maxWidthPerValue[i].maxWidth;
              break;
            }
          }
        }
        const button = resourceManager.createObject('sprite', 'button' + index, this._buttonsContainer, {
          fileName: this._buttonSprite,
          anchor: 0.5,
        });
        const buttonTextWhite = resourceManager.createObject('text', 'button' + index + 'whiteText', button, {
          text: gdk.formatCurrency(stakeController.Stakes[index]),
          fontDefinition: this._buttonTextFontWhite,
          x: this._buttonTextPosOffset.x,
          y: this._buttonTextPosOffset.y,
          maxWidth: maxWidth,
        });

        const buttonTextGreen = resourceManager.createObject('text', 'button' + index + 'greenText', button, {
          text: gdk.formatCurrency(stakeController.Stakes[index]),
          fontDefinition: this._buttonTextFontGreen,
          x: this._buttonTextPosOffset.x,
          y: this._buttonTextPosOffset.y,
          maxWidth: maxWidth,
        });

        button.mousedown = button.touchstart = function () {
          // soundManager.play('hbc_UI_increase_v1');
          self.stakeSelected(index);
        };

        buttonTextGreen.visible = false;
        this._stakeButtons.push({ button, buttonTextWhite, buttonTextGreen, stake });
      }

      if (this._countButtonRows === undefined) {
        this._countButtonsPerRow = Math.floor(maxNumStakeButtons / this._countButtonRows);
      }
      if (this._countButtonRows * this._countButtonsPerRow < maxNumStakeButtons) {
        ++this._countButtonRows;
      }

      this._screenMask = resourceManager.get(this._screenMaskTextId);
      this._screenMask.mousedown = this._screenMask.touchstart = function () {
        self.closeDialog();
        self._cancelledCallback();
      };
    }

    onGameConfigEvent(configEvent) {
      this.initialise();

      resourceManager.get('uiContainer:bg:stake:glow').visible = false;

      resourceManager.get('buttonContainerMobile:reflexButtonBar:stake_portrait:highlight').visible = false;

      this._goldenBetPlatformEnabled = configEvent.data.uiElements.btnUpstake.enabled;
      this._goldenBetPlatformVisible = configEvent.data.uiElements.btnUpstake.visible;

      this._goldenBetStakes = configEvent.data.slotConfig.gameModes.GOLDENBET_BUY.coinSizes.map(function (x) {
        return x * 20;
      });
    }

    onOrientationChange() {
      if (resourceManager.getController('stakeController')) {
        this.updateLayout();
      }
    }

    updateMaxWidths(buttonWidth) {
      if (this._buttonTextMaxWidth === undefined && this.json.maxWidthPerValue === undefined) {
        const width = buttonWidth * 0.8;
        this._stakeButtons.forEach(function (button) {
          button.buttonTextWhite.maxWidth = width;
          button.buttonTextWhite.Props.maxWidth = width;
          button.buttonTextWhite.checkMaxWidth();
          button.buttonTextGreen.maxWidth = width;
          button.buttonTextGreen.Props.maxWidth = width;
          button.buttonTextGreen.checkMaxWidth();
        });
      }
    }

    updateStakes(stakes) {
      this._stakeButtons.forEach(function (button, i) {
        button.buttonTextWhite.setText(gdk.formatCurrency(stakes[i]));
        button.buttonTextGreen.setText(gdk.formatCurrency(stakes[i]));
      });
    }

    goldenBetOnPressed() {
      this._goldenBetButtonOn.interactive = false;
      this._goldenBetButtonOff.interactive = true;

      this._goldenBetButtonOn.visible = false;
      this._goldenBetButtonOff.visible = true;

      this._goldenBetSelected = false;

      let encoreButtonLB = resourceManager.get('goldenBetToggleButton');
      encoreButtonLB.onPressedCallback();

      var stakeController = resourceManager.getController('stakeController');
      this.updateStakes(stakeController.Stakes);

      this.toggleGoldenBetStakes(false);
    }

    goldenBetOffPressed() {
      this._goldenBetButtonOn.interactive = true;
      this._goldenBetButtonOff.interactive = false;

      this._goldenBetButtonOn.visible = true;
      this._goldenBetButtonOff.visible = false;

      this._goldenBetSelected = true;

      let encoreButtonLB = resourceManager.get('goldenBetToggleButton');
      encoreButtonLB.onPressedCallback();

      var stakeController = resourceManager.getController('stakeController');
      this.updateStakes(stakeController.Stakes);

      this.toggleGoldenBetStakes(true);
    }

    goldenBetBackingPressed() {
      if (this._goldenBetSelected) {
        this.goldenBetOnPressed();
      } else {
        this.goldenBetOffPressed();
      }
    }

    toggleGoldenBetStakes(show) {
      if (show) {
        this._stakeButtons.forEach((button) => {
          if (!this._goldenBetStakes.includes(button.stake)) {
            button.button.visible = false;
          }
        });
      } else {
        this._stakeButtons.forEach((button) => {
          button.button.visible = true;
        });
      }
    }

    updateLayout() {
      const stakeController = resourceManager.getController('stakeController');
      const maxNumStakeButtons = stakeController.Stakes.length;

      const buttonWidth =
        this._stakeButtons[0].button.texture.width * resourceManager.selectedAssetResolution.scaleFactor;
      const buttonHeight =
        this._stakeButtons[0].button.texture.height * resourceManager.selectedAssetResolution.scaleFactor;

      this.updateMaxWidths(buttonWidth);

      const allButtonsWidth = buttonWidth * this._countButtonsPerRow;
      const allButtonsHeight = buttonHeight * this._countButtonRows;

      const firstButtonX = -allButtonsWidth / 2;
      const firstButtonY = -allButtonsHeight / 2;
      let x = firstButtonX + buttonWidth / 2;
      let y = firstButtonY + buttonHeight / 2;
      let count = 0;
      for (let row = 0; row < this._countButtonRows; ++row) {
        for (let i = 0; i < this._countButtonsPerRow; ++i) {
          const index = i + row * this._countButtonsPerRow;
          this._stakeButtons[index].button.position.set(x, y);
          x += buttonWidth;
          ++count;
          if (count >= maxNumStakeButtons) {
            break;
          }
        }
        x = firstButtonX + buttonWidth / 2;
        y += buttonHeight;
        if (count >= maxNumStakeButtons) {
          break;
        }
      }
    }

    resetButtons() {
      this._stakeButtons.forEach(function (button) {
        button.buttonTextWhite.visible = true;
        button.buttonTextGreen.visible = false;
      });
    }

    toggleButtons(enable) {
      this._stakeButtons.forEach(function (button) {
        button.button.interactive = enable;
      });
    }

    openDialog(stakes, selectedCallback, cancelledCallback) {
      this.isActive = true;

      this._selectedCallback = selectedCallback;
      this._cancelledCallback = cancelledCallback;
      if (!this._initialLayoutDone) {
        this._initialLayoutDone = true;
        this.updateLayout();
      }

      resourceManager.get('uiContainer:bg:stake:glow').visible = true;

      resourceManager.get('buttonContainerMobile:reflexButtonBar:stake_portrait:highlight').visible = true;

      this.toggleButtons(true);

      this.resetButtons();

      this._screenMask.show(true);
      this.visible = true;

      this._screenMask.interactive = true;

      this._continueButton.alpha = 0.7;
      this._continueButtonWhiteText.visible = true;
      this._continueButtonGreenText.visible = false;
      this._continueButton.interactive = false;
      this._closeButton.interactive = true;

      // set correct state of dialog golden bet button on entry
      let goldenBetButton = resourceManager.get('goldenBetToggleButton');
      this._goldenBetButtonOn.interactive =
        goldenBetButton._flags.showGoldenBetActive && this._goldenBetPlatformEnabled;
      this._goldenBetButtonOff.interactive =
        !goldenBetButton._flags.showGoldenBetActive && this._goldenBetPlatformEnabled;

      this._goldenBetButtonOn.visible = goldenBetButton._flags.showGoldenBetActive && this._goldenBetPlatformVisible;
      this._goldenBetButtonOff.visible = !goldenBetButton._flags.showGoldenBetActive && this._goldenBetPlatformVisible;

      if (this._goldenBetBacking) {
        this._goldenBetBacking.interactive = this._goldenBetPlatformEnabled;
        this._goldenBetBacking.visible = this._goldenBetPlatformEnabled;
      }

      let luckyBetOn = goldenBetButton._flags.showGoldenBetActive && this._goldenBetPlatformEnabled;

      this._goldenBetSelected = luckyBetOn;
      this.toggleGoldenBetStakes(luckyBetOn);

      this._canPlaceGoldenBet = resourceManager.get('goldenBetToggleButton').getCanPlaceBet();

      const stakeController = resourceManager.getController('stakeController');
      this.updateStakes(stakeController.Stakes);

      this.stakeSelected(stakes.indexOf(stakeController.CurrentStake));
    }

    stakeSelected(index) {
      this.resetButtons();
      this._stakeButtons[index].buttonTextGreen.visible = true;
      this._stakeButtons[index].buttonTextWhite.visible = false;
      this._continueButton.alpha = 1;
      this._continueButtonWhiteText.visible = false;
      this._continueButtonGreenText.visible = true;
      this._continueButton.interactive = true;
      this._selectedIndex = index;

      const stakeController = resourceManager.getController('stakeController');
      this._selectedCallback(this._selectedIndex);
      messageBus.post('game:modal', { reason: 'stakeSelection' });

      this._canPlaceGoldenBet = resourceManager.get('goldenBetToggleButton').getCanPlaceBet();

      this._goldenBetButtonOn.visible = gameData.encoreEnabled && this._canPlaceGoldenBet;
      this._goldenBetButtonOff.visible = !gameData.encoreEnabled && this._canPlaceGoldenBet;
    }

    continuePressed() {
      this.isActive = false;
      this._selectedCallback(this._selectedIndex);
      this.closeDialog();
    }

    closeDialog() {
      this.isActive = false;
      this._continueButton.interactive = false;
      this.toggleButtons(false);
      this._closeButton.interactive = false;
      this.visible = false;
      this._screenMask.show(false);

      resourceManager.get('uiContainer:bg:stake:glow').visible = false;

      resourceManager.get('buttonContainerMobile:reflexButtonBar:stake_portrait:highlight').visible = false;
      if (gameController.showStakeChangeMessage) {
        gameController.displayStakeChangePersistenceMessage();
        gameController.showStakeChangeMessage = false;
      }
    }
  }

  var gameStakeSelectionCreator = function (json) {
    return new GameStakeSelection(json);
  };

  var gameStakeSelectionInitialiser = function (json, buggy) {};

  var gameStakeSelectionFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    'gameStakeSelection',
    gameStakeSelectionCreator,
    gameStakeSelectionInitialiser,
    gameStakeSelectionFilesRequired
  );
})();
